module.exports = __webpack_public_path__ + "static/img/dsk-contact-bg.912b233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-contact-bg.jpg
// module id = 227
// module chunks = 1